import { URL, handleErrors } from "./depannageActions"
import { showToast } from "./toastActions"
import { catchApiError } from "./apiHelpers"

//////////////////////////////////////////////////////////////
//        Grille tarifaire police versionnée (GE-8)         //
//////////////////////////////////////////////////////////////
// api/police/grilles : GET liste des versions (+ cellules), POST actions
// {creer_brouillon | sauver | mettre_en_vigueur}, DELETE brouillon. Chaque
// mutation renvoie la liste fraîche → on redispatch le SUCCESS du fetch
// (même pattern que les diagnostiques).

export const FETCH_GRILLES_POLICE_BEGIN = "FETCH_GRILLES_POLICE_BEGIN"
export const FETCH_GRILLES_POLICE_ERROR = "FETCH_GRILLES_POLICE_ERROR"
export const FETCH_GRILLES_POLICE_SUCCESS = "FETCH_GRILLES_POLICE_SUCCESS"
export const POST_GRILLE_POLICE_BEGIN = "POST_GRILLE_POLICE_BEGIN"
export const POST_GRILLE_POLICE_ERROR = "POST_GRILLE_POLICE_ERROR"
export const POST_GRILLE_POLICE_SUCCESS = "POST_GRILLE_POLICE_SUCCESS"
export const POST_GRILLE_POLICE_RESET = "POST_GRILLE_POLICE_RESET"

export const fetchGrillesPoliceSuccess = (grilles) => ({
	type: FETCH_GRILLES_POLICE_SUCCESS,
	payload: { grilles },
})

export const resetPostGrillePolice = () => ({ type: POST_GRILLE_POLICE_RESET })

export function fetchGrillesPolice() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_GRILLES_POLICE_BEGIN })
		return fetch(`${URL}api/police/grilles`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchGrillesPoliceSuccess(json)))
			.catch(
				catchApiError(dispatch, (error) => ({
					type: FETCH_GRILLES_POLICE_ERROR,
					payload: { error },
				})),
			)
	}
}

// action ∈ {creer_brouillon, sauver, mettre_en_vigueur} — cf. PoliceGrilleView.
export function postGrillePolice(payload, successMessage) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: POST_GRILLE_POLICE_BEGIN })
		return fetch(`${URL}api/police/grilles`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(payload),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchGrillesPoliceSuccess(json))
				dispatch({ type: POST_GRILLE_POLICE_SUCCESS })
				if (successMessage) dispatch(showToast("success", successMessage))
				return json
			})
			.catch(
				catchApiError(dispatch, (error) => ({
					type: POST_GRILLE_POLICE_ERROR,
					payload: { error },
				})),
			)
	}
}

export function deleteGrillePolice(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: POST_GRILLE_POLICE_BEGIN })
		return fetch(`${URL}api/police/grilles`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchGrillesPoliceSuccess(json))
				dispatch({ type: POST_GRILLE_POLICE_SUCCESS })
				dispatch(showToast("success", "Brouillon supprimé"))
				return json
			})
			.catch(
				catchApiError(dispatch, (error) => ({
					type: POST_GRILLE_POLICE_ERROR,
					payload: { error },
				})),
			)
	}
}
